export default function createReviewSlider() {
  $('.review-slider').slick({
    fade: true,
    nextArrow: `
      <svg class="slick-next" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 41">
        <path d="M20.3 40.8 0 20.5 20.3.2l.7.7L1.3 20.5 21 40.1z"></path>
      </svg>`,
    prevArrow: `
      <svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 41">
        <path d="M20.3 40.8 0 20.5 20.3.2l.7.7L1.3 20.5 21 40.1z"></path>
      </svg>
    `,
    rows: 0
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/reviewSlider.js